var map = {
	"./PricingGraphic.png": 134,
	"./PricingPackage.png": 870,
	"./Screenshot 2025-03-05 at 2.21.19 PM.png": 985,
	"./ai.png": 178,
	"./crm.png": 794,
	"./dashboard.png": 318,
	"./logo.png": 534,
	"./mail.png": 605,
	"./phone.png": 978,
	"./shop.png": 356,
	"./shopbg.png": 193,
	"./textify1.png": 430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;